import { api } from "../client";

export const getEmployee = (email) => {
  return api.get(`/employee?email=${email}`);
};
